let input1;
let input2;

document.addEventListener("DOMContentLoaded", function() {
    input1 = document.getElementById("new-password");
    input2 = document.getElementById("repeat-password");

    if (input1 && input2) {
        input1.addEventListener("keyup", getPassword);
        input2.addEventListener("keyup", getPassword);
    }
});

function getPassword() {
    var submitBtn = document.getElementById("reset-trigger");
    submitBtn.setAttribute("disabled", true);
    submitBtn.classList.add("btn-disable");

    var text = document.getElementById("new-password").value;
    var pwd2 = document.getElementById("repeat-password").value;

    var length = document.getElementById("length");
    var lowercase = document.getElementById("lowercase");
    var uppercase = document.getElementById("uppercase");
    var number = document.getElementById("number");
    var special = document.getElementById("special");
    var identical = document.getElementById("identical");

    checkIfEightChar(text) ? addClass(length) : removeClass(length);
    checkIfOneLowercase(text) ? addClass(lowercase) : removeClass(lowercase);
    checkIfOneUppercase(text) ? addClass(uppercase) : removeClass(uppercase);
    checkIfOneDigit(text) ? addClass(number) : removeClass(number);
    checkIfOneSpecialChar(text) ? addClass(special) : removeClass(special);
    checkIfPAsswordsAreIdentical(text, pwd2)
        ? addClass(identical)
        : removeClass(identical);

    if (
        checkIfEightChar(text) &&
        checkIfOneLowercase(text) &&
        checkIfOneUppercase(text) &&
        checkIfOneDigit(text) &&
        checkIfOneSpecialChar(text) &&
        checkIfPAsswordsAreIdentical(text, pwd2)
    ) {
        submitBtn.classList.remove("btn-disable");
        submitBtn.removeAttribute("disabled");
    } else {
        submitBtn.setAttribute("disabled", true);
        submitBtn.classList.add("btn-disable");
    }
}

function addClass(element) {
    element.classList.add("list-group-item-success");
}

function removeClass(element) {
    element.classList.remove("list-group-item-success");
}

function checkIfEightChar(text) {
    return text.length >= 8;
}

function checkIfOneLowercase(text) {
    return /[a-z]/.test(text);
}

function checkIfOneUppercase(text) {
    return /[A-Z]/.test(text);
}

function checkIfOneDigit(text) {
    return /[0-9]/.test(text);
}

function checkIfOneSpecialChar(text) {
    return /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>.@½_¨´()¤£€\?]/g.test(text);
}

function checkIfPAsswordsAreIdentical(text, pwd2) {
    if (text === pwd2 && text !== "") {
        return true;
    } else {
        return false;
    }
}

function togglePassword() {
    var passInput = document.getElementById("password");
    var togglePW = document.getElementById("togglePW");

    passInput.type === "password"
        ? (passInput.type = "text")
        : (passInput.type = "password");
    togglePW.textContent === "Show Password"
        ? (togglePW.textContent = "Hide Password")
        : (togglePW.textContent = "Show Password");
}
